import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { initTDK } from './utils/tdk'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 导入 Element Plus 的中英文语言包
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'

// 你原来的样式
import './assets/css/slicy.css'
import './assets/css/style.css'
// import './assets/css/responsive.css'

const app = createApp(App)

// 获取当前语言
const currentLang = localStorage.getItem('locale') || 'zh'

// 配置 Element Plus 国际化
app.use(ElementPlus, {
  locale: currentLang === 'zh' ? zhCn : en
})

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // 用微任务延迟执行回调，错开渲染周期
      requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (err) {}
      });
    });
  }
};

// 使用其他插件
app.use(router)
app.use(i18n)

// 初始化 TDK（标题/关键词/摘要 来自 https://www.marinelinkco.com/server/webSite）
initTDK()

app.mount('#app')